export class YoutubeConsent {

    currentYouTubeVideo = null;
    options = {};
    locales = {};

    constructor(options) {
        this.options = options;
        this.loadLocales();
        this.activateYoutubeConsent();
    }

    activateYoutubeConsent() {

        var youtubeVideos = document.querySelectorAll('.youtube-loading');

        Array.prototype.forEach.call(youtubeVideos, (el, i) => {

            el.addEventListener('click', (e) => {

                e.preventDefault();
                this.getUserConsent(e.currentTarget);

            })
        });

    }

    getUserConsent(youTubeVideo) {

        // store video DOM object so we can reference it later
        this.currentYouTubeVideo = youTubeVideo;
        this.injectConsentMarkup(youTubeVideo);

    }

    injectConsentMarkup(youTubeVideo) {

        const consentMarkup = `
            <div class="youtube-consent-body">
                <p>${this.locales.infoText}</p>
                <div class="btn-group">
                    <button type="button" class="btn btn-secondary" id="reject-youtube-video">${this.locales.reject}</button>
                    <button type="button" class="btn btn-primary" id="confirm-youtube-video">${this.locales.confirm}</button>
                </div>
            </div>`;

        const consent = document.createElement('div');
        consent.classList.add('youtube-consent');
        consent.innerHTML = consentMarkup;

        youTubeVideo.parentElement.appendChild(consent);
        document.querySelector('#confirm-youtube-video').addEventListener('click', () => this.loadYouTubeVideo());
        document.querySelector('#reject-youtube-video').addEventListener('click', () => this.rejectYouTubeVideo());

    }

    loadYouTubeVideo() {
        const youTubeId = this.getYouTubeVideoId();
        this.currentYouTubeVideo.parentElement.innerHTML = this.getYouTubeEmbedCode(youTubeId);
    }

    rejectYouTubeVideo() {
        this.currentYouTubeVideo.parentElement.querySelector('.youtube-consent').remove();
    }

    getYouTubeEmbedCode(youTubeId) {
        return '<div class="video"><iframe width="100%" height="315" src="https://www.youtube-nocookie.com/embed/' + youTubeId + '" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe></div>';
    }

    getYouTubeVideoId() {
        var urlParts = this.currentYouTubeVideo.href;
        return urlParts.split('v=')[1];
    }

    loadLocales() {
        const currentLanguage = this.getLanguage();
        const fallbackLocale = this.options.localeDefault || 'en';
        if (this.options.locales[currentLanguage]) {
            this.locales = this.options.locales[currentLanguage];
        } else {
            this.locales = this.options.locales[fallbackLocale];
        }
    }

    getLanguage() {
        return document.documentElement.lang.split('-')[0];
    }

}


export default YoutubeConsent;
